import React from 'react'
import {removeZeros, round} from '../../utils/misc'
import NumericInput from 'react-numeric-input';

export class CommonInvoiceLevelCheck extends React.Component{

    constructor(props){
      super(props)
      this.handleChange = this.handleChange.bind(this)
    }
    handleChange(e) {
      let value=e.target.checked
      let name = this.props.name
      this.props.onChangeCallback(name, value)
    }
    render(){

      let invoice = this.props.invoice
      let name = this.props.name
      let inputValue = typeof invoice[name] !== "undefined" ? invoice[name]:false
      let check = <div><input type="checkbox" name={name} checked={inputValue} onChange={this.handleChange} /></div>
      return <div>{check}</div>
    }
}

export class CommonInvoiceLevelInput extends React.Component {
  constructor(props){
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }
  handleChange(e) {

    let value=e.target.value
    let name = this.props.name
    this.props.onChangeCallback(name, value)
  }
  render(){
    let invoice = this.props.invoice
    let name = this.props.name
    let inputValue = typeof invoice[name] !== "undefined" ? invoice[name]:""
    let check = <div><input type="text" className="form-control input-sm" name={name} value={inputValue} onChange={this.handleChange} /></div>
    return <div>{check}</div>
  }
}

export class CommonItemLevelInputNumber extends React.Component {

  constructor(){
    super()
    this.state = {touched:false}
  }

  handleChange = (e) =>{
    this.setState({touched:true})
    e.preventDefault()

    let item = this.props.item, value=e.target.value.trim()

    if(value.length) {
      let decimalPortion = value.split(".")[1]
      if(decimalPortion && decimalPortion.length > 6) {
          value = round(value, 6)
      }
    }
    item[this.props.name] = value
    this.props.onChangeCallback(item)
  }

  render() {

    let inputValue = this.props.item[this.props.name]
    if(inputValue > 0){
      if(!this.state.touched) {
          inputValue = removeZeros(inputValue)
      }
    }
    return <div>
        <input type="text" className="form-control input-sm" value={inputValue} ref={this.props.name} onChange={this.handleChange} />
    </div>
  }
}


export class CommonItemLevelTextInput extends React.Component {

  constructor(props){
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    let item = this.props.item, value=e.target.value
    item[this.props.name] = value
    this.props.onChangeCallback(item)
  }


  render() {
    let item = this.props.item
    let inputName = this.props.name
    let placeholder = this.props.placeholder
    let inputType = "text"
    if(typeof this.props.type !== "undefined") {
      inputType = this.props.type
    }


    return <div>
        <input type={inputType} placeholder={placeholder} name={inputName} className="form-control input-sm" value={item[inputName]} onChange={this.handleChange} />
    </div>
  }
}

export default class CommonItemLevelInput extends React.Component {

  constructor(props){
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    let item = this.props.item, value=e.target.value
    item[this.props.name] = value
    this.props.onChangeCallback(item)
  }


  render() {
    let item = this.props.item
    let inputName = this.props.name
    let placeholder = this.props.placeholder
    let inputType = "text"
    if(typeof this.props.type !== "undefined") {
      inputType = this.props.type
    }
    let inputValue
    if(typeof item[inputName] !== "undefined") {
      if (isNaN(item[inputName])) {
        inputValue = ""
      }
      else {
          inputValue = removeZeros(item[inputName])
      }
    }
    else {
      inputValue = ""
    }

    return <div>
        <input type="number" placeholder={placeholder} name={inputName} className="form-control input-sm" value={inputValue} onChange={this.handleChange} />
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/commons/commoninput.js